"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppleProxyGeoListResponseSchema = exports.AppleProxyGeoResponseSchema = exports.AppleProxySearchGeoQuerySchema = exports.AppleProxySearchGeoEntitySchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const _1 = require(".");
const core_1 = require("../../../core");
exports.AppleProxySearchGeoEntitySchema = (0, core_1.StringUnion)([
    "Country",
    "AdminArea",
    "Locality",
]);
exports.AppleProxySearchGeoQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    query: (0, core_1.OptionalNullable)(core_1.SearchStringSchema),
    entity: (0, core_1.OptionalNullable)(exports.AppleProxySearchGeoEntitySchema),
    countrycode: (0, core_1.OptionalNullable)(core_1.CountrySchema),
});
exports.AppleProxyGeoResponseSchema = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    entity: exports.AppleProxySearchGeoEntitySchema,
    displayName: typebox_1.Type.String(),
    countryOrRegion: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    adminArea: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    locality: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
});
exports.AppleProxyGeoListResponseSchema = typebox_1.Type.Object({
    data: (0, core_1.OptionalNullable)(typebox_1.Type.Array(exports.AppleProxyGeoResponseSchema)),
    pagination: (0, core_1.OptionalNullable)(_1.AppleProxyPageDetailSchema),
});
